import { buildQueryString } from './Functions'
import TemplateUtils from 'utils/TemplateUtils'
import { API_BASE, SEO_SERVICES_PATH} from '../consts'

var Enum = {}

// these ids must match the checks db table ids
// advisorType is legacy and can be removed when dependent analytics don't need it anymore
Enum.CheckTypes = {
  seoproblems: {
    key: 'seoproblems',
    id: 1,
    name: 'SEO problems',
    canAdhocCheck: true,
    disableable: false,
    advisorType: 'SEOProblems',
    onlyForPlus: false,
    surveyLinks: {
      free: 'https://plug-in-useful.typeform.com/to/AR3RUR',
      plus: 'https://plug-in-useful.typeform.com/to/yWEdlo'
    }
  },
  blog: {
    key: 'blog',
    id: 3,
    name: 'Blog',
    canAdhocCheck: false,
    disableable: true,
    advisorType: 'Blog',
    onlyForPlus: false,
    surveyLinks: {
      free: 'https://plug-in-useful.typeform.com/to/r6B9Ev',
      plus: 'https://plug-in-useful.typeform.com/to/wPivmZ'
    }
  },
  notfound: {
    key: 'notfound',
    id: 4,
    name: 'Broken links',
    canAdhocCheck: false,
    disableable: true,
    advisorType: 'NotFound',
    onlyForPlus: false
  }
}

Enum.getCheckFromId = function(id) {
  for (let key in Enum.CheckTypes) {
    if (Enum.CheckTypes[key].id === id) return Enum.CheckTypes[key]
  }

  return null
}

Enum.ReviewApps = [
  { value: 'autodetect', label: 'Auto-Detect' },
  { value: 'judgeme', label: 'Judge.me' },
  { value: 'loox', label: 'Loox' },
  { value: 'opinew', label: 'Opinew' },
  { value: 'shopify_product_reviews', label: 'Shopify Product Reviews' },
  { value: 'stamped', label: 'Stamped.io' },
  { value: 'rivyo', label: 'Rivyo' }
]

Enum.ISOCountries = {
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua And Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia And Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, Democratic Republic',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Cote D'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island & Mcdonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic Of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle Of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KR: 'Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyan Arab Jamahiriya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States Of',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  AN: 'Netherlands Antilles',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory, Occupied',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthelemy',
  SH: 'Saint Helena',
  KN: 'Saint Kitts And Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre And Miquelon',
  VC: 'Saint Vincent And Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome And Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia And Sandwich Isl.',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard And Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad And Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks And Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis And Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe'
}

Enum.SocialLinks = {
  fb: {
    key: 'fb',
    id: 1,
    name: 'Facebook',
    domain: 'facebook.com',
    prefix: 'https://facebook.com',
    icon: 'facebook',
    color: '#3B5998'
  },
  instagram: {
    key: 'instagram',
    id: 2,
    name: 'Instagram',
    domain: 'instagram.com',
    prefix: 'https://instagram.com',
    icon: 'instagram',
    color: '#E4405F'
  },
  twitter: {
    key: 'twitter',
    id: 3,
    name: 'Twitter',
    domain: 'twitter.com',
    prefix: 'https://twitter.com',
    icon: 'twitter',
    color: '#1DA1F2'
  },
  youtube: {
    key: 'youtube',
    id: 4,
    name: 'Youtube',
    domain: 'youtube.com',
    prefix: 'https://youtube.com',
    icon: 'youtube',
    color: '#FF0000'
  },
  linkedin: {
    key: 'linkedin',
    id: 5,
    name: 'Linkedin',
    domain: 'linkedin.com',
    prefix: 'https://linkedin.com',
    icon: 'linkedin',
    color: '#0077B5'
  },
  space: {
    key: 'space',
    id: 6,
    name: 'Myspace',
    domain: 'myspace.com',
    prefix: 'https://myspace.com',
    icon: 'myspace',
    color: '#030303'
  },
  pin: {
    key: 'pin',
    id: 7,
    name: 'Pinterest',
    domain: 'pinterest.com',
    prefix: 'https://pinterest.com',
    icon: 'pinterest',
    color: '#BD081C'
  },
  scloud: {
    key: 'scloud',
    id: 8,
    name: 'SoundCloud',
    domain: 'soundcloud.com',
    prefix: 'https://soundcloud.com',
    icon: 'soundcloud',
    color: '#FF3300'
  },
  tmblr: {
    key: 'tmblr',
    id: 9,
    name: 'Tumblr',
    domain: 'tumblr.com',
    prefix: 'https://tumblr.com',
    icon: 'tumblr',
    color: '#36465D'
  }
}

Enum.Verdict = {
  NoIssuesNoUserActionRequired: 'NoIssuesNoUserActionRequired',
  MinorIssuesUneconomicalForUserToFix: 'MinorIssuesUneconomicalForUserToFix',
  IssuesUserShouldConsiderFix: 'IssuesUserShouldConsiderFix',
  MajorIssuesUserShouldFix: 'MajorIssuesUserShouldFix'
}

Enum.ExecuteResult = {
  couldNotGetHtml:
    "We could not access the HTML code of your webpage. This check requires accesses to the source code of your website to check the SEO.",
  success: 'Success.',
  invalidUri:
    "The url entered is invalid. This check requires access to a valid webpage.",
  couldNotLoadHtml:
    "We could not load the HTML code of your webpage. This check requires accesses to the source code of your website to check the SEO. The website URL is valid but the HTML code could not be understood by our app.",
  isNotHtml:
    "We cannot detect any HTML on this page. This check requires accesses to the source code of your website to check the SEO. The website URL is valid but the content does not look like HTML.",
  informationRequired: 'Set up required.',
  passwordProtected:
    'We have detected that website shop is password-protected. This check requires accesses to the source code of your website. While your shop is protected by a password we are able able to access the source code. You can temporarily remove the password and run this check again.',
  exception: 'Something unusual went wrong. ',
  upgradeRequired: 'This feature is only available in Plug in SEO Plus'
}

// Template Formula and Checklists

const CommonTemplateNode = {
  shopName: {
    key: 'shop.name',
    text: 'Shop Name',
    fixed: true,
    template: '%% shop.name %%'
  },
  shopDomain: {
    key: 'shop.domain',
    text: 'Shop Domain',
    fixed: true,
    template: '%% shop.domain %%'
  },
  blogTitle: {
    key: 'blog.title',
    text: 'Blog Title',
    fixed: true,
    template: '%% blog.title %%'
  },
  pageTitle: {
    key: 'page.title',
    text: 'Page Title',
    fixed: true,
    template: '%% page_title %%'
  },
  articleTitle: {
    key: 'article.title',
    text: 'Article title',
    fixed: true,
    template: '%% article.title %%'
  },
  productTitle: {
    key: 'title',
    text: 'Product Title',
    fixed: true,
    template: '%% product.title %%'
  },
  getStatic: (key, text, render = true) => ({
    key: `static.${key}`,
    text: text,
    fixed: true,
    static: true,
    template: render && text
  }),
  getTagsList: ({
    key = 'tag',
    text,
    template,
    count,
    addMore = false,
    renderMore = false,
    skipSpace = false,
    moreText = 'and more'
  }) => {
    const tags = [
      { key: `${key}.primary`, text: text, fixed: true, skipSpace, template }
    ]

    for (let i = 0; i < count - 1; i++) {
      tags.push({
        key: `${key}.delimiter${i}`,
        text: ',',
        fixed: true,
        static: true
      })
      tags.push({
        key: `${key}.secondary${i}`,
        text: text,
        fixed: true
      })
    }

    if (addMore)
      tags.push({
        key: 'tag.more',
        text: moreText,
        fixed: true,
        static: true,
        template: renderMore && moreText
      })

    return tags
  }
}

Enum.TitleTemplateChecklist = {
  Product: [
    {
      text:
        'Plug in SEO automatically creates a page title template for your products.'
    },
    {
      text: 'Add a short description of your products.',
      condition: 'description',
      instructions: [
        'Keep your description between 3-5 words',
        'Use 1-2 keywords or keyphrases'
      ],
      critical: false
    }
  ],
  Collection: [
    {
      text:
        'Plug in SEO automatically creates a page title template for your collections.'
    }
  ],
  Article: [
    {
      text: 'Plug in SEO automatically creates a page title for your articles.'
    }
  ],
  Blog: [
    { text: 'Plug in SEO automatically creates a page title for your blogs.' }
  ],
  Page: [
    { text: 'Plug in SEO automatically creates a page title for your pages.' },
    {
      text: 'Add a short description about your brand and products.',
      condition: 'description',
      instructions: [
        'Should be between 8-12 words',
        'Use 2-3 keywords',
        'Format as a sentence, not a list',
        'Highlight what makes your shop unique'
      ],
      critical: false
    }
  ],
  Catalog: [
    {
      text:
        'Plug in SEO automatically creates a page title for your catalog page.'
    }
  ],
  Search: [
    { text: 'Plug in SEO automatically creates a page title for your search.' }
  ],
  '404': [
    {
      text: 'Plug in SEO automatically creates a page title for your 404 pages.'
    }
  ],
  Default: [
    {
      text:
        'Plug in SEO automatically creates a page title for any page that doesn’t have one already.'
    },
    {
      text: 'Add a short description about your shop.',
      condition: 'description',
      instructions: [
        'Keep your description between 3-5 words',
        'Use 1-2 keywords or keyphrases'
      ],
      critical: false
    }
  ],
  Index: [
    {
      text: 'Create a custom page title for your homepage.',
      condition: 'template',
      instructions: [
        'Should be no longer than a sentence',
        'Use 4-5 keywords or keyphrases',
        'Format as a sentence, not a list',
        'Summarize the products that you sell and what makes your shop unique'
      ],
      critical: true
    }
  ]
}

Enum.DescriptionTemplateChecklist = {
  Product: [
    {
      text:
        'Plug in SEO automatically creates a page description for your products.'
    },
    {
      text: 'Add additional details.',
      condition: 'description',
      instructions: [
        'Description should encourage customers to click',
        'Include key selling points (ex. free shipping, return policy, organic, locally made, etc)',
        'Format as a sentence, not a list of keywords'
      ],
      critical: false,
      optional: true
    }
  ],
  Collection: [
    {
      text:
        'Plug in SEO automatically creates a collection description for your products.'
    },
    {
      text: 'Add a short summary of your products.',
      condition: 'summary',
      instructions: [
        'Should be 3-5 words',
        'Summarize what you’re selling',
        'Include 1-2 keywords'
      ],
      critical: false
    },
    {
      text: 'Add a sentence describing your brand and products.',
      condition: 'description',
      instructions: [
        'Should be 8-12 words',
        'Emphasize what makes your brand and product unique',
        'Format as a sentence, not a list of keywords'
      ],
      critical: false
    }
  ],
  Article: [
    {
      text:
        'Plug in SEO automatically creates a page description for your articles.'
    }
  ],
  Blog: [
    {
      text:
        'Plug in SEO automatically creates a page description for your blogs.'
    }
  ],
  Page: [
    {
      text:
        'Plug in SEO automatically creates a page description for your pages.'
    },
    {
      text: 'Add a sentence about why people should visit your shop.',
      condition: 'description',
      instructions: [
        'Should be 5-12 words',
        'Promote why people should shop at your store',
        'Format as a sentence, not a list of keywords'
      ],
      critical: false
    }
  ],
  Catalog: [
    {
      text:
        'Plug in SEO automatically creates a page description for your catalog page.'
    }
  ],
  Search: [
    {
      text:
        'Plug in SEO automatically creates a page description for your search.'
    }
  ],
  '404': [
    {
      text:
        'Plug in SEO automatically creates a page description for your 404 pages.'
    }
  ],
  Default: [
    {
      text:
        'Plug in SEO automatically creates a page description for any page that doesn’t have one already.'
    },
    {
      text: 'Add 1-2 sentences about your shop.',
      condition: 'description',
      instructions: [
        'Write 1-2 sentences',
        'Explain what makes your brand and products special',
        'Format as sentences, not a list of keywords'
      ],
      critical: false
    }
  ],
  Index: [
    {
      text: 'Create a custom page description for your homepage.',
      condition: 'template',
      instructions: [
        'Should be 2-3 sentences',
        'Explain what makes your brand and products unique',
        'Format as sentences, not a list of keywords'
      ],
      critical: true
    }
  ]
}

Enum.TitleTemplateFormula = {
  Product: [
    CommonTemplateNode.productTitle,
    {
      key: 'selected_variant.title',
      text: 'Selected Product Variant',
      fixed: true,
      skipSpace: true,
      template: "%% product.selected_variant.title || prepend_not_empty: ' ' %%"
    },
    {
      key: 'separator',
      toggler: 'description',
      fixed: false,
      separator: true,
      template: '|'
    },
    {
      key: 'description',
      text: 'Add a short description',
      hint: 'ex. stock photo t-shirts for designers',
      fixed: false
    }
  ],
  Collection: [
    CommonTemplateNode.getStatic('shop', 'Shop'),
    {
      key: 'tags',
      text: 'Current Tags',
      fixed: true,
      template: "%% current_tags || join: ', ' || append_not_empty: ' ' %%"
    },
    {
      key: 'collection.title',
      text: 'Collection title',
      fixed: true,
      skipSpace: true,
      template: '%% collection.title || escape %%'
    },
    CommonTemplateNode.getStatic('at', 'at'),
    CommonTemplateNode.shopName
  ],
  Article: [
    CommonTemplateNode.articleTitle,
    { key: 'separator1', fixed: true, text: '|' },
    ...CommonTemplateNode.getTagsList({
      text: 'Article Tag',
      count: 3,
      addMore: true,
      skipSpace: true,
      template:
        "%% article.tags || take: '3' || join: ', ' || prepend_not_empty: ' | ' || append_not_empty: ' and more' %%"
    }),
    { key: 'separator2', fixed: true, separator: true, template: '|' },
    CommonTemplateNode.shopName,
    CommonTemplateNode.blogTitle,
    CommonTemplateNode.getStatic('blog', 'blog')
  ],
  Blog: [
    CommonTemplateNode.shopName,
    CommonTemplateNode.blogTitle,
    CommonTemplateNode.getStatic('blog', 'blog:', false),
    ...CommonTemplateNode.getTagsList({
      text: 'Blog Tag',
      count: 5,
      addMore: true,
      skipSpace: true,
      template:
        "%% blog.all_tags || take: '5' || join: ', ' || prepend_not_empty: ' blog: ' || append_not_empty: ' and more' %%"
    })
  ],
  Page: [
    CommonTemplateNode.pageTitle,
    {
      key: 'separator',
      toggler: 'description',
      fixed: false,
      separator: true,
      template: '|'
    },
    {
      key: 'description',
      text: 'Add a short description',
      hint: 'ex. Stock Photo Tees for high quality clichéd t-shirt designs',
      fixed: false
    }
  ],
  Catalog: [
    CommonTemplateNode.getStatic('browse', 'Browse'),
    ...CommonTemplateNode.getTagsList({
      text: 'Product Collection Title',
      count: 5,
      template:
        "%% collection.products || map: 'collections' || map: 'title' || uniq || take: '5' || join: ', ' || escape || remove: 'Home page, ' || remove: 'home page, '  || remove: 'Home page' || remove: 'Home page'  %%"
    }),
    CommonTemplateNode.getStatic('at', 'at'),
    CommonTemplateNode.shopName
  ],
  Search: [
    CommonTemplateNode.getStatic('shop', 'Shop'),
    {
      key: 'search.terms',
      text: 'Search Terms',
      fixed: true,
      template: '%% search.terms %%'
    },
    CommonTemplateNode.getStatic('at', 'at'),
    CommonTemplateNode.shopName
  ],
  '404': [
    CommonTemplateNode.getStatic('404', '404: Page Not Found -'),
    CommonTemplateNode.shopName
  ],
  Default: [
    CommonTemplateNode.pageTitle,
    {
      key: 'separator.1',
      toggler: 'description',
      fixed: false,
      separator: true,
      template: '|'
    },
    {
      key: 'description',
      text: 'Add a short description',
      hint: 'ex. Stock Photo Clichés on T-shirts',
      fixed: false
    },
    { key: 'separator.2', fixed: true, separator: true, template: '|' },
    CommonTemplateNode.shopName
  ],
  Index: 'ex. Stock Photo Clichés on T-shirts: high quality Stock Photo Tees'
}

Enum.DescriptionTemplateFormula = {
  Product: [
    {
      key: 'description',
      text: 'Add additional details',
      hint: 'ex. We offer free shipping and free returns.',
      fixed: false
    },
    {
      key: 'product.desc',
      text: 'Product Description',
      fixed: true,
      template:
        "%% product.description || strip_newlines || replace: '.,', ',' || strip_html || escape %%"
    }
  ],
  Collection: [
    CommonTemplateNode.getStatic('shop', 'Shop', false),
    ...CommonTemplateNode.getTagsList({
      text: 'Collection Tag',
      count: 3,
      addMore: true,
      template:
        "%% collection.all_tags || take: '3' || join: ', ' || prepend_not_empty: 'Shop ' || append_not_empty: ' and more ' %%"
    }),
    {
      key: 'title',
      text: 'Collection title',
      fixed: true,
      skipSpace: true,
      template: '%% collection.title || escape %%'
    },
    CommonTemplateNode.getStatic('at', 'at'),
    CommonTemplateNode.shopName,
    {
      key: 'separator',
      toggler: 'summary',
      fixed: false,
      separator: true,
      skipSpace: true,
      template: ':'
    },
    {
      key: 'summary',
      text: 'Summary of your products',
      hint: 'ex. cheesy t-shirts for designers.',
      fixed: false
    },
    {
      key: 'collection.desc',
      text: 'Collection description',
      fixed: true,
      template:
        '%% collection.description || strip_html || strip_newlines || escape || strip %%'
    },
    {
      key: 'description',
      text: 'Description of your brand and products',
      hint:
        'ex. Stock photo tees of business cliches, exaggerated expressions and retro technology.',
      fixed: false
    }
  ],
  Article: [
    {
      key: 'article.exerpt',
      text: 'Article Excerpt',
      fixed: true,
      template:
        '%% article.excerpt_or_content || strip_newlines || strip_html || escape %%'
    },
    CommonTemplateNode.getStatic('readAbout', 'Read about', false),
    ...CommonTemplateNode.getTagsList({
      text: 'Article Tag',
      skipSpace: true,
      count: 5,
      addMore: true,
      template:
        "%% article.tags || take: '6' || join: ', ' || prepend_not_empty: ' Read about ' || append_not_empty: ' and more' %%"
    }),
    CommonTemplateNode.articleTitle,
    CommonTemplateNode.getStatic('onThe', 'on the'),
    CommonTemplateNode.shopName,
    CommonTemplateNode.blogTitle,
    CommonTemplateNode.getStatic('blog', 'blog')
  ],
  Blog: [
    CommonTemplateNode.getStatic('readAbout', 'Read about', false),
    ...CommonTemplateNode.getTagsList({
      text: 'Blog Article',
      count: 3,
      addMore: true,
      renderMore: false,
      moreText: 'and more on the',
      template:
        "%% blog.articles || map: 'title' || take: '3' || join: ', ' || prepend_not_empty: 'Read about ' || append_not_empty: ' and more on the '%%"
    }),
    { ...CommonTemplateNode.shopName, skipSpace: true },
    CommonTemplateNode.blogTitle,
    CommonTemplateNode.getStatic('blog', 'blog.')
  ],
  Page: [
    {
      key: 'page.content',
      text: 'Page Content',
      fixed: true,
      template:
        "%% page.content || strip_newlines || strip_html || escape || append_not_empty: '.' %%"
    },
    CommonTemplateNode.getStatic('visit', 'Visit'),
    CommonTemplateNode.shopName,
    {
      key: 'separator',
      toggler: 'description',
      fixed: false,
      separator: true,
      template: 'to'
    },
    {
      key: 'description',
      text: 'Why people should visit your shop',
      hint:
        'ex. celebrate the stock photograph with a range of t-shirts and sweaters.',
      fixed: false
    }
  ],
  Catalog: [
    CommonTemplateNode.getStatic('discover', 'Discover'),
    ...CommonTemplateNode.getTagsList({
      text: 'Collection Product',
      count: 3,
      addMore: true,
      renderMore: true,
      moreText: 'and more.',
      template:
        "%% collection.products || map: 'title' || uniq || take: '3' || join: ', ' || escape %%"
    })
  ],
  Search: [
    CommonTemplateNode.getStatic('find', 'Find'),
    {
      key: 'search.terms',
      text: 'Search terms',
      fixed: true,
      template:
        "%% search.terms || default: 'it' %% here%% search.results || map: 'title' || take: '3' || join: ', ' || prepend_not_empty: ' including ' || append_not_empty: ' and more' %%"
    },
    CommonTemplateNode.getStatic('andMore', 'and more', false),
    CommonTemplateNode.getStatic('at', 'at'),
    CommonTemplateNode.shopName
  ],
  '404': [
    CommonTemplateNode.getStatic(
      '404',
      "The page you requested can't be found, please visit"
    ),
    CommonTemplateNode.shopDomain,
    CommonTemplateNode.getStatic('instead', 'instead')
  ],
  Default: [
    {
      key: 'page.description',
      text: 'Page Description',
      fixed: true,
      template: '%% page_description %%'
    },
    {
      key: 'description',
      text: '1-2 sentences about your shop',
      hint:
        'ex. Celebrate the stock photograph with a range of t-shirts and sweaters.\nWe hope to create a paradigm shift in apparel production with \na cookie-cutter approach to design.',
      fixed: false
    }
  ],
  Index:
    'ex. A place to celebrate the stock photograph with a range of t-shirts and sweaters. We hope to create a paradigm shift in apparel production with a cookie-cutter approach to design.'
}

Enum.CustomTemplateLearnLink =
  'https://support.pluginuseful.com/en/articles/10684979-using-liquid-code-in-plug-in-seo'
Enum.CustomTemplateExampleLinks = {
  Product:
    'https://support.pluginuseful.com/hc/en-us/articles/23534781904148-How-do-I-customise-my-product-title-and-description-templates',
  Collection:
    'https://support.pluginuseful.com/hc/en-us/articles/23534793842452-How-do-I-customise-my-collection-title-and-description-templates',
  Article:
    'https://support.pluginuseful.com/hc/en-us/articles/23534854618260-How-do-I-customise-my-article-title-and-description-templates',
  Blog:
    'https://support.pluginuseful.com/hc/en-us/articles/23534849616532-How-do-I-customise-my-blog-title-and-description-templates',
  Page:
    'https://support.pluginuseful.com/hc/en-us/articles/23534814631188-How-do-I-customise-my-pages-title-and-description-templates',
  Catalog:
    'https://support.pluginuseful.com/hc/en-us/articles/23534869558164-How-do-I-customise-my-catalog-title-and-description-templates',
  Search:
    'https://support.pluginuseful.com/hc/en-us/articles/23534846199316-How-do-I-customise-my-search-title-and-description-templates',
  '404':
    'https://support.pluginuseful.com/hc/en-us/articles/23534823336852-How-do-I-customise-my-404-title-and-description-templates',
  Default:
    'https://support.pluginuseful.com/hc/en-us/articles/23534783235348-How-do-I-customise-my-default-title-and-description-templates',
  Index:
    'https://support.pluginuseful.com/hc/en-us/articles/23534793211668-How-do-I-write-a-strong-homepage-title-and-description'
}

Enum.BlimponLinkLocations = {
  checksPage: 'checks_home',
  getItFixedPage: 'get_it_fixed_page',
  pageTop: 'top',
  pageBottom: 'bottom'
}

Enum.GenerateBlimponUrl = (packageType, plusUser, location) => {
  let path
  const domain = 'http://www.blimpon.com'

  let query
  if(location === Enum.BlimponLinkLocations.pageTop ||
    location === Enum.BlimponLinkLocations.pageBottom) {
    query = {
      utm_campaign: 'get_it_fixed',
      utm_medium: 'plug_in_seo'
    }

    query['utm_content'] = plusUser ? 'plus' : 'free'
    query['utm_source'] = `check_${location}`
  } else {
    query = {
      utm_source: 'plug in seo app',  
      utm_medium: 'app dashboard',
      utm_campaign: 'seo service',
    }
    
    if (location === Enum.BlimponLinkLocations.getItFixedPage) {
      query['utm_medium'] = 'get it fixed';
    }
  }

  const baseServiceUrl = API_BASE + SEO_SERVICES_PATH;

  switch (packageType) {
    case 'speed':
      path = 'pages/speed-up-your-shopify-store-compass'
      break
    case Enum.CheckTypes.seoproblems.id:
      return `${baseServiceUrl}?${buildQueryString(query)}`
    case Enum.CheckTypes.blog.id:
      return `${baseServiceUrl}?${buildQueryString(query)}`
    default:
      return domain
  }

  return `${domain}/${path}?${buildQueryString(query)}`
}

Enum.StoreTaskerUrl =
  'https://www.storetasker.com/service/on-page-seo-fixes-with-plug-in-seo?rfsn=2929181.8180321'

Enum.OnboardingChecklists = {
  home: [
    'Explain what makes your brand and products unique',
    'Include 3-5 keywords and keyphrases',
    'Format as sentences, not a list of keywords'
  ],
  title: [
    'Emphasize the top qualities of your product (ex. affordable, organic, locally made, etc)',
    'Include 2-3 keywords and keyphrases'
  ],
  description: [
    'Description should encourage customers to click',
    'Include key selling points (ex. free shipping, return policy, locally made, etc)',
    'Format as a sentence, not a list of keywords'
  ]
}

Enum.OnboardingTitles = {
  home: 'Optimize your Homepage SEO',
  title: 'Optimize your Page Titles',
  description: 'Optimize your Meta Descriptions'
}

Enum.OnboardingVariables = {
  home: [
    {
      key: 'homePrimary',
      placeholder: 'Add a page title for your homepage',
      hint: 'ex. Stock Photo Clichés on T-shirts: high quality Stock Photo Tees'
    },
    {
      key: 'homeSecondary',
      placeholder: 'Add a page description for your homepage',
      hint:
        'ex. A place to celebrate the stock photograph with a range of t-shirts and sweaters. We hope to create a paradigm shift in apparel production with a cookie-cutter approach to design.'
    }
  ],
  title: [
    {
      key: 'titlePrimary',
      placeholder: 'Add a short 3-5 word summary of your products',
      hint: 'ex. Stock photo t-shirts for designers'
    },
    {
      key: 'titleSecondary',
      placeholder: 'Add a 8-12 word description of your brand and products',
      hint: 'ex. Stock Photo Tees for high quality clichéd t-shirt designs'
    }
  ],
  description: [
    {
      key: 'descriptionPrimary',
      placeholder:
        'Add a 8-12 word sentence describing your brand and products',
      hint:
        'ex. Stock photo tees of business cliches, exaggerated expressions and retro technology.'
    },
    {
      key: 'descriptionSecondary',
      placeholder:
        'Add a 5-12 word sentence about why people should visit your shop',
      hint:
        'ex. celebrate the stock photograph with a range of t-shirts and sweaters.'
    }
  ]
}

Enum.OnboardingTemplateGenerate = ({
  homePrimary,
  homeSecondary,
  titlePrimary,
  titleSecondary,
  descriptionPrimary,
  descriptionSecondary
}) => {
  const templates = {}
  const collectionDescTemplateVariables = {}

  // home primary
  if (homePrimary) templates['pageTitleIndexTemplate'] = homePrimary
  // home secondary
  if (homeSecondary) templates['metaDescriptionIndexTemplate'] = homeSecondary

  // title primary
  if (titlePrimary) {
    templates['pageTitleProductTemplate'] = TemplateUtils.generateTemplate(
      Enum.TitleTemplateFormula['Product'],
      { description: titlePrimary }
    )
    collectionDescTemplateVariables['summary'] = titlePrimary
  }
  // title secondary
  if (titleSecondary) {
    templates['pageTitlePageTemplate'] = TemplateUtils.generateTemplate(
      Enum.TitleTemplateFormula['Page'],
      { description: titleSecondary }
    )
    templates['pageTitleDefaultTemplate'] = TemplateUtils.generateTemplate(
      Enum.TitleTemplateFormula['Default'],
      { description: titleSecondary }
    )
  }

  // desc primary
  if (descriptionPrimary) {
    templates[
      'metaDescriptionDefaultTemplate'
    ] = TemplateUtils.generateTemplate(
      Enum.DescriptionTemplateFormula['Default'],
      { description: descriptionPrimary }
    )
    collectionDescTemplateVariables['description'] = descriptionPrimary
  }
  // desc secondary
  if (descriptionSecondary)
    templates['metaDescriptionPageTemplate'] = TemplateUtils.generateTemplate(
      Enum.DescriptionTemplateFormula['Page'],
      { description: descriptionSecondary }
    )

  if (Object.keys(collectionDescTemplateVariables).length)
    templates[
      'metaDescriptionCollectionTemplate'
    ] = TemplateUtils.generateTemplate(
      Enum.DescriptionTemplateFormula['Collection'],
      collectionDescTemplateVariables
    )

  return templates
}

Enum.SearchConsoleIntervals = {
  day: { label: 'Days', count: 30 },
  week: { label: 'Weeks', count: 12 }
}
Enum.CheckTitles = {
  Title: 'Page title',
  'Meta Tags': 'META description',
  Filenames: 'Filenames',
  Heading: 'Headings',
  Images: 'Image ALT tags',
  'Body Text': 'Body text',
  'Internal Links': 'Internal links',
  Subheadings: 'Subheadings',
  'Blog Backlinks': 'Post links',
  'Blog Frequency': 'Frequency',
  'Blog on Own Domain': 'Own domain',
  'Blog Posts': 'Post lengths',
  'Blog Posts Titles': 'Post titles',
  'Exposes Syndication': 'Feed'
}

const generic_keywords_check_items_details = {
  none: "Your keywords haven't been included.",
  one: 'Only one of your keywords has been included.',
  multiple: 'Perfect! Your keywords have been included {{ count }} times.'
}

Enum.CheckItemsDetails = {
  title_length: {
    empty: 'There is an empty HTML title tag on this page.',
    possibly_not_set:
      "Check the HTML title tag has been set on this page, it may contain words like 'untitled'",
    quite_long: 'Best practice is to keep your page titles around 50-60 characters, but going beyond it won’t hurt your SEO performance.',
    too_short: 'Your page title is too short. Best practice is to keep your page titles around 50-60 characters, but going beyond it won’t hurt your SEO performance.',
  },
  multiple_titles: {
    multiple: 'There is more than one HTML title tag on this page',
    none: "There's no HTML title tag on this page"
  },
  multiple_meta_descriptions: {
    none:
      "There's no META HTML tag of type description in the HEAD of this page.",
    multiple:
      "There's more than one META HTML tag of type description in the HEAD of this page."
  },
  multiple_h_1: {
    none: "There's no H1 tag on this page.",
    multiple: "There's more than one H1 tag on this page."
  },
  internal_links: {
    fail: "There are no links to other pages on your website's domain name."
  },
  includes_h_2_or_h_3: {
    fail: 'There are no H2 or H3 heading tags on this page.'
  },
  blog_posts_content_length: {
    some_under_100_words:
      'At least one of the last three posts includes at least 100 words',
    all_under_100_words:
      'Your last three posts all include less than 100 words. Checked:',
    failed_to_execute:
      "We couldn't run this check. Ensure that your Blog Feed URL is set right, or that your blog exposes a valid Atom or RSS feed."
  },
  blog_backlinks: {
    zero_backlinks:
      "Your last three posts don't include any links to your primary website URL or a subdomain of it.",
    under_three_backlinks:
      'Your last three posts include a total of less than three links to your primary website URL or a subdomain of it.',
    failed_to_execute:
      "We couldn't run this check. Ensure that your Blog Feed URL is set right, or that your blog exposes a valid Atom or RSS feed."
  },
  exposes_syndication: {
    fail: 'Your blog should be available as an Atom or RSS feed.'
  },
  blog_frequency: {
    failed_to_execute:
      "We couldn't run this check. Ensure that your Blog Feed URL is set right, or that your blog exposes a valid Atom or RSS feed.",
    fail:
      "You haven't blogged in the last {{ rangeDaysAgo }} days. Your blog was last updated: {{ updated }}"
  },
  blog_posts_title_length: {
    under_4_words: 'The following post titles are under four words:',
    over_50_words: 'The following post titles are over fifty words:',
    failed_to_execute:
      "We couldn't run this check. Ensure that your Blog Feed URL is set right, or that your blog exposes a valid Atom or RSS feed."
  },
  blog_on_own_domain: {
    fail:
      "Your blog at: {{ blogDomain }} doesn't appear to be on your main website domain: {{ siteDomain }}"
  },
  page_title_keywords: generic_keywords_check_items_details,
  body_text_keywords: generic_keywords_check_items_details,
  heading_keywords: generic_keywords_check_items_details,
  subheading_keywords: generic_keywords_check_items_details,
  image_alts_keywords: generic_keywords_check_items_details,
  meta_description_keywords: generic_keywords_check_items_details,
  contentful_h_1: {
    invalid_tag: 'One or more of your H1 tags includes non-text content, such as a link or image.',
    empty: 'There is an empty H1 tag on this page.'
  }
}

Enum.pageTemplates = {
  index: '/plus/manage/index',
  catalog: '/plus/manage/catalog',
  collection: '/plus/manage/collection',
  product: '/plus/manage/product',
  blogHome: '/plus/manage/blog',
  blogPost: '/plus/manage/article',
  page: '/plus/manage/page',
  other: '/plus/manage'
}

module.exports = Enum



// WEBPACK FOOTER //
// ./app/utils/Enum.js